import React from 'react';
import { Copy } from "lucide-react";
import { getAuthOtpButtonText } from '../../../pages/whatsapp/constants/templateConstants';

const AuthTemplateContent = ({
  currentTime,
  codeExpirationMinutes,
  otpButtonText,
  addSecurityRecommendation,
  bodyText,
  language = 'en',
  code = ''
}) => {
  const renderBodyText = () => {

    const parts = (bodyText || '').split('{}');
    return (
      <>
        {parts.map((part, index) => (
          <React.Fragment key={index}>
            {part}
            {index < parts.length - 1 && (
              <span className="font-semibold">{code || '{}'}</span>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };

  const buttonText = getAuthOtpButtonText(language);

  return (
    <div className="bg-white dark:bg-[#1f2c34] max-w-[90%] overflow-hidden p-4 space-y-3 rounded-lg rounded-tl-none shadow-sm">
      <div className="space-y-1">
        <p className="text-sm text-gray-900 dark:text-white leading-snug whitespace-pre-wrap">
          {renderBodyText()}
        </p>
        <div className="flex justify-between items-center">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Expires in {codeExpirationMinutes} minutes.
          </p>
          <span className="text-[10px] text-gray-400 dark:text-gray-500">{currentTime}</span>
        </div>
      </div>

      {addSecurityRecommendation && (
        <div className="text-xs text-gray-600 dark:text-gray-300 pt-1 border-t border-gray-200 dark:border-gray-700">
          Don't share this code with anyone. We'll never ask for it.
        </div>
      )}

      <div className="border-t border-gray-200 dark:border-gray-700 pt-3 -mx-3 px-3">
        <button className="w-full bg-transparent dark:bg-transparent rounded-md inline-flex items-center justify-center gap-2 text-blue-500 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition">
          <Copy className="h-4 w-4" />
          <span className="text-sm font-medium">{otpButtonText || buttonText}</span>
        </button>
      </div>
    </div>
  );
};

export default AuthTemplateContent;
